import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authApi, auth } from '../../services/api';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await authApi.login(username, password);
      auth.save(data);
      navigate('/admin');
    } catch {
      setError('账号或密码错误，请重试');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <img src="/favicon.png" alt="logo" style={styles.logo} />
        <h1 style={styles.title}>CouponerRed</h1>
        <p style={styles.sub}>运营管理后台</p>
        <form onSubmit={handleSubmit} style={styles.form}>
          <input
            type="text"
            placeholder="账号"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            style={styles.input}
            autoFocus
            autoCapitalize="none"
          />
          <input
            type="password"
            placeholder="密码"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
          />
          {error && <div style={styles.error}>{error}</div>}
          <button type="submit" style={styles.btn} disabled={loading || !username || !password}>
            {loading ? '登录中...' : '登录'}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: '#f9fafb',
  },
  card: {
    background: '#fff', borderRadius: 16, padding: '40px 36px',
    width: 320, boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
    display: 'flex', flexDirection: 'column', alignItems: 'center',
  },
  logo: { width: 72, height: 72, borderRadius: 16, marginBottom: 16 },
  title: { fontSize: 22, fontWeight: 700, color: '#111', margin: 0 },
  sub: { fontSize: 13, color: '#999', marginTop: 4, marginBottom: 28 },
  form: { width: '100%', display: 'flex', flexDirection: 'column', gap: 12 },
  input: {
    width: '100%', padding: '11px 14px', border: '1px solid #e5e7eb',
    borderRadius: 8, fontSize: 15, outline: 'none', boxSizing: 'border-box',
  },
  error: { color: '#FA1C51', fontSize: 13, textAlign: 'center' },
  btn: {
    padding: '11px 0', background: '#FA1C51', color: '#fff',
    border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 600,
    cursor: 'pointer', width: '100%',
  },
};
